import { Navigate, useLocation } from "react-router-dom";

/** Merge the incoming query/hash onto a redirect target (target params win). */
export function buildRedirectTarget(target: string, search: string, hash = ""): string {
  const extra = search.length > 1 ? (target.includes("?") ? "&" : "?") + search.slice(1) : "";
  return `${target}${extra}${hash}`;
}

/**
 * Redirect-shim loader that preserves the incoming query string.
 *
 * The consolidated hubs (Design Studio, Overview, Analytics, Knowledge) are
 * reached through legacy deep links such as `/social/compose?design_id=…`.
 * A fixed `<Navigate to>` dropped the query, so hand-offs (design → composer,
 * calendar → composer prefill, attention-panel filters) silently lost their
 * params. The target's own params win on conflict (first value is read).
 */
export function redirectPreservingQuery(target: string) {
  function RedirectWithQuery() {
    const { search, hash } = useLocation();
    return <Navigate replace to={buildRedirectTarget(target, search, hash)} />;
  }
  return () => Promise.resolve({ default: RedirectWithQuery });
}
